import PractitionerScreen from './AppointmentScreen'
export default PractitionerScreen
